import api from './api'

/**
 * Gestão IA — proxy para o serviço Python aiengine.
 *
 * O trabalho roda no servidor: cria-se o turno, recebe-se um id e faz-se polling
 * incremental por cursor. Fechar a aba ou perder internet NÃO interrompe o turno —
 * ao reabrir, `sessionDetail` devolve o histórico completo para reatar.
 *
 * Quem é o dono de cada conversa e quem mais a enxerga é decidido no servidor, a partir da
 * identidade do token. Nada aqui escolhe usuário ou tenant: o front só pede.
 */

/** Escopo de compartilhamento de uma conversa. Espelha `VISIBILIDADES` do motor. */
export const VISIBILIDADES = {
  privada: { valor: 'privada', rotulo: 'Privada', descricao: 'Só você vê esta conversa.' },
  tenant: { valor: 'tenant', rotulo: 'Tenant', descricao: 'Quem opera o mesmo tenant também vê e pode continuar.' },
  global: { valor: 'global', rotulo: 'Global', descricao: 'Todos com acesso à Gestão IA veem e podem continuar.' },
}

export const aiEngineApi = {
  async createSession({ title = '', tenantId = null, tenantName = null, visibilidade = 'privada' } = {}) {
    const { data } = await api.post('/ai-engine/sessions', { title, tenantId, tenantName, visibilidade })
    return data
  },

  async listSessions(includeArchived = false) {
    const { data } = await api.get('/ai-engine/sessions', { params: { includeArchived } })
    return data
  },

  /** Histórico completo (turnos + eventos) — usado para reatar. */
  async sessionDetail(sessionId) {
    const { data } = await api.get(`/ai-engine/sessions/${sessionId}`)
    return data
  },

  /** Só o dono renomeia; os demais recebem 403 do motor. */
  async renameSession(sessionId, title) {
    const { data } = await api.patch(`/ai-engine/sessions/${sessionId}`, { title })
    return data
  },

  /** Compartilhar com o tenant / globalmente, ou voltar a privada. Só o dono. */
  async setVisibilidade(sessionId, visibilidade) {
    const { data } = await api.patch(`/ai-engine/sessions/${sessionId}/visibilidade`, { visibilidade })
    return data
  },

  /** Arquivar guarda o histórico — não apaga nada. */
  async archiveSession(sessionId) {
    const { data } = await api.delete(`/ai-engine/sessions/${sessionId}`)
    return data
  },

  async unarchiveSession(sessionId) {
    const { data } = await api.post(`/ai-engine/sessions/${sessionId}/unarchive`)
    return data
  },

  async createTurn(sessionId, prompt) {
    const { data } = await api.post(`/ai-engine/sessions/${sessionId}/turns`, { prompt })
    return data
  },

  async getTurn(turnId, cursor = 0) {
    const { data } = await api.get(`/ai-engine/turns/${turnId}`, { params: { cursor } })
    return data
  },

  async cancelTurn(turnId) {
    const { data } = await api.post(`/ai-engine/turns/${turnId}/cancel`)
    return data
  },
}

export default aiEngineApi
